import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Zap } from "lucide-react";
import { BarsLogo } from "../components/Logo";
import LoadingScreen from "../components/LoadingScreen";

function LoadingPreview() {
  const [showing, setShowing] = useState(false);
  const show = () => {
    setShowing(true);
    setTimeout(() => setShowing(false), 3000);
  };
  return (
    <>
      <button onClick={show} disabled={showing}
        className="px-4 py-2 rounded border border-[#2A2A2A] text-[12px] text-[#A1A1AA] hover:text-[#EDEDED] hover:bg-[#1a1a1a] disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
        {showing ? "Showing for 3s…" : "▶  Preview Full Loading Screen (3s)"}
      </button>
      {showing && (
        <div className="fixed inset-0 z-[9999]">
          <LoadingScreen />
        </div>
      )}
    </>
  );
}

export default function DevLab() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#EDEDED]">
      {/* Header */}
      <div className="border-b border-[#2A2A2A] px-6 py-4 flex items-center gap-3">
        <button onClick={() => nav(-1)}
          className="p-1.5 rounded hover:bg-[#1a1a1a] text-[#A1A1AA] hover:text-[#EDEDED] transition-colors">
          <ArrowLeft className="w-4 h-4" />
        </button>
        <div className="flex items-center gap-2">
          <Zap className="w-4 h-4 text-[#5A90F5]" />
          <h1 className="text-sm font-semibold">Dev Lab</h1>
          <span className="px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-[#5A90F5]/15 text-[#5A90F5]">DEV</span>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-8 space-y-8">

        {/* Loading animation */}
        <section className="space-y-4">
          <h2 className="text-[11px] font-semibold uppercase tracking-widest text-[#52525B]">Loading Animation</h2>

          {/* Inline live preview */}
          <div className="border border-[#2A2A2A] rounded-lg p-6 bg-[#0c0c0c]">
            <p className="text-[11px] text-[#A1A1AA] mb-4">Live preview</p>
            <div className="flex items-end justify-center gap-6 bg-[#0A0A0A] rounded-lg p-8 h-24">
              <BarsLogo size={56} color="#EDEDED" animated />
            </div>
            <p className="text-[10px] text-[#3F3F46] mt-3 text-center">
              2.0s cycle · bars at 0°, 90°, 180° phase offset
            </p>
          </div>

          {/* Size comparison */}
          <div className="border border-[#2A2A2A] rounded-lg p-6 bg-[#0c0c0c]">
            <p className="text-[11px] text-[#A1A1AA] mb-4">Size variants</p>
            <div className="flex items-end justify-around bg-[#0A0A0A] rounded-lg p-6">
              <div className="flex flex-col items-center gap-2">
                <BarsLogo size={24} color="#EDEDED" animated />
                <span className="text-[9px] text-[#3F3F46]">24px</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <BarsLogo size={40} color="#EDEDED" animated />
                <span className="text-[9px] text-[#3F3F46]">40px</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <BarsLogo size={56} color="#EDEDED" animated />
                <span className="text-[9px] text-[#3F3F46]">56px</span>
              </div>
              <div className="flex flex-col items-center gap-2">
                <BarsLogo size={72} color="#EDEDED" animated />
                <span className="text-[9px] text-[#3F3F46]">72px</span>
              </div>
            </div>
          </div>

          {/* Full-screen trigger */}
          <LoadingPreview />
        </section>

        <div className="border-t border-[#2A2A2A] pt-6">
          <p className="text-[11px] text-[#3F3F46]">More dev tools will appear here as features are built.</p>
        </div>
      </div>
    </div>
  );
}
